import { SelectOption } from "../utils/adhoc-request";
import { RepresentativeApplyProps } from "./api";

export interface OnboardData {
  name: string;
  dob: any;
  gender: string;
  state_id: string;
  local_government_id: string;
}
export interface OnboardVerifyAccountData {
  name: string;
  dob: string;
  gender: string;
  state_id: number;
  local_government_id: number;
}
export const OnboardVerifyAccountDummyData = {
  name: "",
  dob: "",
  gender: "",
  state_id: 0,
  local_government_id: 0,
};
export interface OnboardApiData {
  name: string;
  dob: string | null;
  gender: string;
  state_id: string;
  local_government_id: string;
}
export interface OnboardApiKycData {
  name: string;
  dob: string | null;
  gender: string;
  state_id: string;
  local_government_id: string;
  kyc: any;
}

export interface OnboardContentProps {
  next: () => void;
  user_data: OnboardData;
  states: SelectOption[];
  lga: SelectOption[];
  setUser_data: React.Dispatch<React.SetStateAction<OnboardData>>;
}

export interface OnboardContentScreenTwoProps {
  prev: () => void;
  user_data: OnboardData;
  setUser_data: React.Dispatch<React.SetStateAction<OnboardData>>;
}

export interface OnboardContentTwoProps {
  user_data: OnboardData;
  setUser_data: React.Dispatch<React.SetStateAction<OnboardData>>;
}

export interface RespsOne {
  next: () => void;
  resp_data: RepresentativeApplyProps;
  setResp_data: React.Dispatch<React.SetStateAction<RepresentativeApplyProps>>;
}
